import(/* webpackMode: "eager", webpackExports: ["routes"] */ "/vercel/path0/landing-page/components/global-container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.4_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.54.1_babel-plugin-_54wu5ozmy64loxhrbfvvoxsy54/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/packages/shared-ui/src/components/Footer.tsx");
